import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'RDF-Schema' ontology */
export const ns = createNS("http://www.w3.org/2000/01/rdf-schema#");
/* Classes */
/** The class resource, everything. */
export const Resource = /*#__PURE__*/ ns("Resource");
/** The class of classes. */
export const Class = /*#__PURE__*/ ns("Class");
/** The class of literal values, eg. textual strings and integers. */
export const Literal = /*#__PURE__*/ ns("Literal");
/** The class of RDF containers. */
export const Container = /*#__PURE__*/ ns("Container");
/** The class of container membership properties, rdf:_1, rdf:_2, ...,
                    all of which are sub-properties of 'member'. */
export const ContainerMembershipProperty = /*#__PURE__*/ ns("ContainerMembershipProperty");
/** The class of RDF datatypes. */
export const Datatype = /*#__PURE__*/ ns("Datatype");
/* Properties */
/** The subject is a subclass of a class. */
export const subClassOf = /*#__PURE__*/ ns("subClassOf");
/** The subject is a subproperty of a property. */
export const subPropertyOf = /*#__PURE__*/ ns("subPropertyOf");
/** A description of the subject resource. */
export const comment = /*#__PURE__*/ ns("comment");
/** A human-readable name for the subject. */
export const label = /*#__PURE__*/ ns("label");
/** A domain of the subject property. */
export const domain = /*#__PURE__*/ ns("domain");
/** A range of the subject property. */
export const range = /*#__PURE__*/ ns("range");
/** Further information about the subject resource. */
export const seeAlso = /*#__PURE__*/ ns("seeAlso");
/** The defininition of the subject resource. */
export const isDefinedBy = /*#__PURE__*/ ns("isDefinedBy");
/** A member of the subject resource. */
export const member = /*#__PURE__*/ ns("member");
/* Other terms */
